module.exports = __webpack_public_path__ + "img/44-ABITO-MAKUMBA-U-COLORI-LINO43-ABITO-PROSECCO-U-COLORI-LINO-STAMPE-LINO9.ad4b9066.jpg";